import { Component, Input } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'app-locker-render',
    templateUrl: './locker-render.component.html',
    styleUrls: ['./locker-render.component.scss']
})
export class LockerRenderComponent {

    @Input() modelo: any;
    @Input() cromado: any;
    @Input() extColor: any;
    @Input() intColor: any;
    @Input() watchShelves: Array<any>;
    @Input() glassShelves: Array<any>;
    @Input() glassShelvesPosition: Array<any>;
    @Input() shelves: Array<any>;
    @Input() status: Array<any>;
    @Input() lockerStatusArray: Array<any>;
    @Input() selectedStatus: any;

    private showLid: boolean;

    ngOnInit() {
        this.showLid = true;
    }
}